/**
 * Returns the cohort for a specific flag, otherwise returns a default value.
 *
 * @param {Context} ctx - The request context, which contains experiences.
 * @param {string} name - The name of the flag.
 * @param {number | null} [fallback=null] - The default value to fallback to.
 * @returns {number | null}
 */

interface Experience {
  cohort?: number;
}

interface Context {
  experiences?: Record<string, Experience>;
}

const cohort = (ctx: Context, name: string, fallback: number | null = null): number | null => {
  const experiences = ctx.experiences || {};
  const experience = experiences[name];

  return experience?.cohort ?? fallback;
};

export default cohort;
